import { render, staticRenderFns } from "./Crown2.vue?vue&type=template&id=17eff1d9&scoped=true"
import script from "./Crown2.vue?vue&type=script&lang=js"
export * from "./Crown2.vue?vue&type=script&lang=js"
import style0 from "./Crown2.vue?vue&type=style&index=0&id=17eff1d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eff1d9",
  null
  
)

export default component.exports